module.exports = __webpack_public_path__ + "static/media/slide_6.19b4be95.jpg";